import React from "react";

import { Button, Card, Heading, Text } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { clickedNewSearch } from "../../../../../../tracking/account-tracking";

export const NoUpcomingTrips: React.FC = () => {
  const { translator, urlBuilder, tracker } = useAppContext();

  return (
    <Card
      className="flex flex-row justify-center px-400 py-300 md:px-200 md:py-600"
      elevation="sunken"
    >
      <div className="flex flex-col items-center justify-center gap-300">
        <div className="flex flex-col items-center justify-center gap-100">
          <Heading size="sm" as="span" className="text-center">
            {translator.t("!accounts.my-tickets.no-upcoming-trips")}
          </Heading>
          <Text size="md" as="span" className="text-color-tertiary">
            {translator.t("!accounts.trips.explore-world")}
          </Text>
        </div>
        <Button
          size="lg"
          url={urlBuilder.home()}
          onClick={() => tracker.track(clickedNewSearch())}
          className="w-full sm:w-auto"
          appearance="primary"
        >
          {translator.t("!accounts.my-tickets.empty.button")}
        </Button>
      </div>
    </Card>
  );
};
